import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import ContactForm from "../forms/contactForm";
import CtaOffer from "../common/ctaOffer";

function Offer2WycinkaDrzew() {
  return (
    <>
      {/* HERO */}
      <section className="relative overflow-x-hidden flex flex-col lg:flex-row items-center justify-between lg:min-h-[60vh] p-6 lg:px-12 lg:pt-48 lg:pb-36 gap-6">
        <img
          className="absolute w-full h-full object-cover z-10 top-0 left-0"
          src="https://magazyn.drzewus.pl/wp-content/uploads/2025/02/timber-harvesting-a-lot-of-logs-lying-on-the-grou-2023-11-27-05-19-20-utc-Large.jpeg"
          alt="Wycinka drzew - drewno po wycięciu - Drzewus"
        />
        <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr"></div>
        <div className="flex flex-col items-start justify-center gap-2 z-30">
          <h1 className="text-3xl lg:text-6xl text-white text-left">
            Wycinka drzew i karczowanie działek pod inwestycje Gdańsk, Kaszuby
          </h1>
          <h2 className="text-xl lg:text-3xl text-white text-left">
            Szybkie usuwanie drzew i krzewów z placu budowy na Pomorzu
          </h2>
          <p className="text-white text-base lg:text-xl max-w-[850px] text-left">
            Planujesz nową inwestycję w Gdańsku, Gdyni, Wejherowie lub na Kaszubach i potrzebujesz szybkiego oczyszczenia placu budowy? Zapewniamy kompleksową wycinkę drzew kolidujących z planowanym budynkiem, ogrodzeniem czy wjazdem. Uzupełnieniem usługi jest <a href="/oczyszczanie-terenu/frezowanie-pni" className="underline hover:opacity-80">frezowanie pni</a> oraz wywóz biomasy, co pozwala od razu rozpocząć właściwe prace budowlane.
          </p>
          <a href="#wiecej">
            <button className="button-yellow">Dowiedz się więcej</button>
          </a>
        </div>
        <div className="z-30 max-w-[500px] flex flex-col items-center justify-center">
          {" "}
          <ContactForm />
        </div>
      </section>
      {/* CONTENT */}
      <section
        id="wiecej"
        className="p-6 lg:px-24 lg:py-12 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-12"
      >
        <div className="lg:col-span-1 flex flex-col gap-6">
          <div className="flex flex-col gap-2 p-6 rounded-xl bg-green w-full">
            <a
              href="#1"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Na czym polega wycinka metodą klasyczną?
            </a>
            <a
              href="#2"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Czy samodzielna wycinka jest bezpieczna?
            </a>
            <a
              href="#3"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Przepisy dotyczące wycinania drzew
            </a>
            <a
              href="#4"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Kiedy konieczne jest wycięcie drzewa
            </a>
            <a
              href="#5"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Powody, dla których możesz usunąć drzewo
            </a>
            <a
              href="#6"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Gdzie wycinamy drzewa – nasz obszar działania
            </a>
            <a
              href="#7"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Wycinka drzew – cennik
            </a>
          </div>
          <CtaOffer />
        </div>
        <div className="lg:col-span-2 flex flex-col items-start justify-start text-left gap-2 content-offer">
          <h2 id="1">Na czym polega wycinka metodą klasyczną?</h2>
          <p>
            Tradycyjne ścinanie drzew z poziomu ziemi przy użyciu pilarek łańcuchowych to sprawdzona metoda na otwartych przestrzeniach. Wymaga ona precyzyjnego wyznaczenia kierunku obalania pnia przez doświadczonego pilarza, aby zapewnić pełne bezpieczeństwo otoczenia.
          </p>

          <h2 id="2">Czy samodzielna wycinka jest bezpieczna?</h2>
          <p>
            Samodzielne próby obalania dużych drzew stwarzają ogromne ryzyko. Brak doświadczenia może skutkować zakleszczeniem prowadnicy pilarki lub, co gorsza, niekontrolowanym upadkiem pnia na pobliskie budynki, ogrodzenia lub linie napowietrzne. Niewłaściwa technika zagraża również zdrowiu osób postronnych.
          </p>
          <p>
            Zlecając wycinkę naszej firmie, zyskujesz pewność, że prace zostaną wykonane profesjonalnie i bezpiecznie. Nasi arborysty potrafią precyzyjnie ocenić stan statyczny drzewa i dobrać najwłaściwszą technikę cięcia. Gdy warunki na to pozwalają, działamy szybko z poziomu gruntu, natomiast przy gęstej zabudowie stosujemy wycinkę sekcyjną metodą linową.
          </p>

          <h2 id="3">Przepisy dotyczące wycinania drzew</h2>
          <p>
            Polskie przepisy dopuszczają usunięcie niektórych drzew bez zgody urzędu, opierając się na obwodzie pnia mierzonym tuż nad gruntem (na wysokości 5 cm). Ponieważ normy różnią się w zależności od gatunku drzewa, nasz dendrolog na miejscu zweryfikuje wymogi prawne dla Twojego drzewostanu.
          </p>
          <p>
            Również okres lęgowy ptaków stawia przed inwestorami dodatkowe wyzwania. Aby wycinka była zgodna z ustawą o ochronie przyrody, zlecamy kontrolę ornitologiczną, co gwarantuje brak opóźnień przy załatwianiu zgód administracyjnych.
          </p>

          <h2 id="4">Kiedy konieczne jest wycięcie drzewa</h2>
          <p>
            Zdarza się, że stare, chore lub uszkodzone przez czynniki atmosferyczne drzewa zagrażają bezpieczeństwu domowników i mienia. W takich momentach kluczowa jest szybka reakcja i usunięcie niebezpiecznego drzewa.
          </p>

          <h3 id="5">Powody, dla których możesz usunąć drzewo:</h3>
          <ul>
            <li>drzewo jest martwe</li>
            <li>drzewo jest chore</li>
            <li>drzewo jest uszkodzone po burzy</li>
            <li>drzewo zasłania widok</li>
            <li>drzewo jest niebezpiecznie pochylone</li>
            <li>drzewo rośnie zbyt blisko zabudowań</li>
            <li>drzewo będzie przeszkadzać w budowie</li>
          </ul>
          <p>
            Niezależnie od przyczyny wycinki – czy to plany budowlane, czy chęć zyskania większej ilości światła – po prostu wskaż nam odpowiednie drzewa, a my zajmiemy się całą procedurą.
          </p>

          <h2 id="6">Gdzie wycinamy drzewa – nasz obszar działania</h2>
          <p>
            Oferujemy usługi wycinki dla klientów indywidualnych oraz firm i deweloperów. Nasz zespół działa na obszarze Trójmiasta oraz całego województwa pomorskiego, zapewniając sprawną realizację nawet trudnych zleceń.
          </p>

          <h2 id="7">Wycinka drzew – cennik</h2>
          <p>
            Koszt usunięcia drzewa zależy od jego wysokości, średnicy pnia, bliskości zabudowań i wybranej metody pracy. Do wyceny bardzo pomocne są zdjęcia drzewa i jego otoczenia – możesz je przesłać przez nasz formularz. W przypadku skomplikowanych zleceń bezpłatnie przyjedziemy na oględziny.
          </p>
          <p>
            Zabezpiecz swoją posesję przed niespodziewanymi skutkami wichur i nawałnic. Skontaktuj się z nami już dziś po bezpłatną wycenę. Zorganizujemy cały proces – od formalności urzędowych, przez wycięcie, aż po posprzątanie terenu i wywóz gałęzi.
          </p>
        </div>
      </section>
      {/* PORTFOLIO */}
      <section className="p-6 lg:px-24 lg:py-12 flex flex-col gap-6">
        <div className="flex flex-col lg:flex-row items-start justify-start lg:items-center lg:justify-between gap-6 lg:gap-24">
          <div className="flex flex-col items-start justify-start gap-2 w-full">
            {" "}
            <h2 className="uppercase color-yellow text-xl">Nasze realizacje</h2>
            <h3 className="text-3xl lg:text-5xl color-green text-left">
              Spójrz jak pomogliśmy<br></br>
              <span className="color-yellow">naszym Klientom</span>
            </h3>
          </div>
          <div className="flex flex-col items-start justify-center w-full lg:w-2/3">
            <p className="text-gray-600 text-left">
              Sprawdź, jak sprawnie oczyszczamy działki oraz realizujemy wycinkę drzew na trudnych terenach. Od 15 lat dbamy o bezpieczeństwo i porządek podczas prac przygotowawczych pod budowę.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/realizacja-1.jpg"
              alt="Wycinka drzew - realizacja Drzewus nr 1"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-3">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/02/Realizacja-2.jpg"
              alt="Wycinka drzew - realizacja Drzewus nr 2"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-4.png"
              alt="Wycinka drzew - realizacja Drzewus nr 3"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-1">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/realizacja-4.jpg"
              alt="Wycinka drzew - realizacja Drzewus nr 4"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/02/Realizacja-1.jpg"
              alt="Wycinka drzew - realizacja Drzewus nr 5"
              className="h-full object-cover w-full"
            />
          </div>
        </div>
      </section>
      {/* <section className="p-6 lg:px-24 lg:py-12 flex flex-col gap-6">
        <div className="flex flex-col items-center justify-center mb-6">
          <h2 className="uppercase color-yellow text-xl text-center">
            Nasze realizacje
          </h2>
          <h3 className="text-3xl lg:text-5xl color-green text-center">
            Spójrz jak pomogliśmy<br></br>
            <span className="color-yellow">naszym Klientom</span>
          </h3>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-1.png"
              alt="Portfolio Drzewus nr 1"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-2.png"
              alt="Portfolio Drzewus nr 2"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-1">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-3.png"
              alt="Portfolio Drzewus nr 3"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-4.png"
              alt="Portfolio Drzewus nr 4"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-1">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-5.png"
              alt="Portfolio Drzewus nr 5"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-6.png"
              alt="Portfolio Drzewus nr 6"
              className="h-full object-cover w-full"
            />
          </div>
        </div>
      </section> */}
    </>
  );
}

export default Offer2WycinkaDrzew;
